import { IconWrapper } from '../runtime';
export default IconWrapper('view-in-calendar', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6.4375 14.2498H3.25C2.42157 14.2498 1.75 13.5782 1.75 12.7498V6.06794M1.75 6.06794V4.49976C1.75 3.67133 2.42157 2.99976 3.25 2.99976H12.75C13.5784 2.99976 14.25 3.67133 14.25 4.49976V6.06794H1.75Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M14.75 14.7498L13.5 13.4998M5 2.88379V0.883789M11 2.88379V0.883789M14 11.2498C14 12.7685 12.7688 13.9998 11.25 13.9998C9.73122 13.9998 8.5 12.7685 8.5 11.2498C8.5 9.73097 9.73122 8.49976 11.25 8.49976C12.7688 8.49976 14 9.73097 14 11.2498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});